import React, { lazy, Suspense } from "react";
import DialogHeader from "./footer/DialogHeader";
import DialogInviteUsersFooter from "./DialogInviteUsersFooter";

const DialogOnlyWrapper = lazy(() =>
  import("./DialogOnlyWrapper").then((mod) => ({
    default: mod.default,
  })),
);

interface DialogInviteUsersProps {
  isOpen: boolean;
  handleClose: () => void;
  onDeleteClick: () => void;
  onResendClick?: () => void;
  handleFooterSubmit: (e?: React.FormEvent) => void;
  children: React.ReactNode;
  title: string;
  subtitle: string;
  submit: string;
  label: string;
  label1: string;
  invitasionDisable?: boolean;
  isShowBtn?: boolean;
  isSubmitting?: boolean;
  HorizontalLine?: boolean;

}

const DialogInviteUsers: React.FC<DialogInviteUsersProps> = ({
  isOpen,
  handleClose,
  onDeleteClick,
  onResendClick,
  handleFooterSubmit,
  children,
  title,
  subtitle,
  submit,
  label,
  label1,
  invitasionDisable,
  isShowBtn,
  isSubmitting = false,
  HorizontalLine,
}) => {
  const isSuccessScreen =
    React.isValidElement(children) &&
    children.type &&
    (children.type as any).name === "RequestToPaySuccess";

  if (!isOpen) return null;

  return (
    <Suspense fallback={<div />}>
      <DialogOnlyWrapper>
        <div className="gx-dialog-box">
          <DialogHeader
            handleClose={handleClose}
            title={title}
            subtitle={subtitle}
          />

          <div className="gx-dialog-main">{children}</div>

          {!isSuccessScreen && (
            <DialogInviteUsersFooter
              submit={submit}
              handleFooterSubmit={handleFooterSubmit}
              label1={label1}
              label={label}
              hideBTN={isShowBtn}
              onDeleteClick={onDeleteClick}
              onResendClick={onResendClick}
              disable={invitasionDisable}
              isSubmitting={isSubmitting}
              HorizontalLine={HorizontalLine}
            />
          )}
        </div>
      </DialogOnlyWrapper>
    </Suspense>
  );
};

export default DialogInviteUsers;
